import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { ForeignBusinessAdviceModel } from './types';
import { foreignBusinessAdviceItemValidator } from './validators/item';

const foreignBusinessAdviceValidator: ValidateJSModel<ForeignBusinessAdviceModel> = {
  HasForeignAdvice: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasForeignAdvice?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignBusinessAdviceItemValidator },
      };
    }

    return {};
  },
};
export default foreignBusinessAdviceValidator;
